import {lockSvg as Icon__small__lockSvg} from '../Icon__small/Icon__small--lock.js';

export var lock = {
  name: 'lock',
  category: 'icon',
  colorable: true,
  svg: Icon__small__lockSvg,
};
